import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class GroupBySearchService {
  constructor(
    private httpClient: HttpClient,
  ) { }

  public canSearchProducts(customerName: string, isViewer: boolean): Observable<boolean> {
    const searchBody = {
      area: isViewer ? `${customerName}Pub` : customerName,
      collection: isViewer ? `${customerName}Pub` : customerName,
    };
    const url = this.searchEndpoint();
    return this.httpClient.post(url, searchBody, { headers: { 'Content-Type': 'application/json' } })
      .map(() => {
        return true;
      })
      .catch(() => {
        return Observable.of(false);
      });
  }

  private searchEndpoint(): string {
    return `${environment.baseUrlv2}/api/v2/search`;
  }
}



// WEBPACK FOOTER //
// ./src/app/editor/services/gb-search.service.ts